import React from 'react';
import { AdminCrudShell } from '@/components/admin/AdminCrudShell';
import { Badge } from '@/components/ui/badge';

const SCOPE_OPTS = [
  { value: 'event', label: 'Evento concreto' },
  { value: 'club', label: 'Club' },
  { value: 'platform', label: 'Plataforma' },
];

const STATUS_OPTS = [
  { value: '', label: 'Todos' },
  { value: 'active', label: 'Activo' },
  { value: 'expired', label: 'Expirado' },
  { value: 'revoked', label: 'Revocado' },
];

const SOURCE_OPTS = [
  { value: '', label: 'Todas' },
  { value: 'purchase', label: 'Compra' },
  { value: 'subscription', label: 'Suscripción' },
  { value: 'manual', label: 'Manual (admin)' },
];

const SOURCE_BADGE = {
  purchase: 'bg-[var(--ns-gold)]/20 text-[var(--ns-gold-700)]',
  subscription: 'bg-blue-100 text-blue-800',
  manual: 'bg-purple-100 text-purple-800',
};

export default function AdminEntitlements() {
  return (
    <AdminCrudShell
      title="Accesos (entitlements)"
      subtitle="Otorga accesos manuales por soporte/cortesía y consulta los existentes."
      entity="entitlements"
      testIdPrefix="admin-entitlements"
      
      addLabel="Conceder acceso manual"
      filters={[
        { name: 'status', label: 'Estado', options: STATUS_OPTS },
        { name: 'source_type', label: 'Origen', options: SOURCE_OPTS },
      ]}
      initialForm={{ user_id: '', event_id: '', club_id: '', access_scope: 'event', ends_at: '', notes: '' }}
      columns={[
        { key: 'user_id', label: 'Usuario', render: (r) => <span className="text-xs font-mono">{(r.user_id||'').slice(0,8)}…</span> },
        { key: 'source_type', label: 'Origen', render: (r) => <Badge className={`text-[10px] uppercase ${SOURCE_BADGE[r.source_type] || ''}`}>{r.source_type}</Badge> },
        { key: 'access_scope', label: 'Scope' },
        { key: 'event_id', label: 'Evento', render: (r) => r.event_id ? <span className="text-xs font-mono">{r.event_id.slice(0,8)}…</span> : <span className="text-[var(--ns-text-subtle)]">—</span> },
        { key: 'club_id', label: 'Club', render: (r) => r.club_id ? <span className="text-xs font-mono">{r.club_id.slice(0,8)}…</span> : <span className="text-[var(--ns-text-subtle)]">—</span> },
        { key: 'status', label: 'Estado' },
        { key: 'ends_at', label: 'Vence' },
        { key: 'notes', label: 'Notas' },
      ]}
      formFields={[
        { name: 'user_id', label: 'Usuario (UUID)', required: true, placeholder: 'UUID del usuario', lowercase: false },
        { name: 'access_scope', label: 'Scope', type: 'select', required: true, options: SCOPE_OPTS },
        { name: 'event_id', label: 'Evento (UUID) — solo si scope=event', placeholder: 'UUID del evento', dependsOn: (v) => v.access_scope === 'event', lowercase: false },
        { name: 'club_id', label: 'Club (UUID) — solo si scope=club', placeholder: 'UUID del club', dependsOn: (v) => v.access_scope === 'club', lowercase: false },
        { name: 'ends_at', label: 'Caduca el (ISO 8601, opcional)', placeholder: '2030-01-01T00:00:00Z', lowercase: false },
        { name: 'notes', label: 'Notas (opcional)', type: 'textarea', placeholder: 'Cortesía por incidencia…' },
      ]}
    />
  );
}
